import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ConceptValues } from '../../../../models/concept-values.model';
import { GeneralService } from '../../../../services/general/general.service';
import { Concept } from '../../../../models/concept.model';
import { Minister } from '../../../../models/minister.model';
import { MinisterService } from '../../../../services/minister/minister.service';
import { Child } from '../../../../models/Child.model';
import { AcademicTraining } from '../../../../models/AcademicTraining.model';
import { MinisterialTraining } from '../../../../models/MinisterialTraining.model';

import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ChurchService } from '../../../../services/church/church.service';
import { Church } from '../../../../models/church.model';
import { MatDialog } from '@angular/material';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { LoginService } from '../../../../services/login/login.service';



@Component({
  selector: 'app-postulate-minister',
  templateUrl: './postulate-minister.component.html',
  styleUrls: ['./postulate-minister.component.scss']
})
export class PostulateMinisterComponent implements OnInit {
  panelOpenState = false;
  panelChildrenOpenState = false;

  // VARIABLES PARA CONTROLAR EL AUTOCOMPLETE DE IGLESIAS
  myControl = new FormControl();
  optionsChurches: Church[] = [];
  allChurches: Church[] = [];
  filteredChurches: Observable<Church[]>;
  churchSelected: Church;

  //LISTAS DE VALOR
  academicLevels: ConceptValues;
  ministerAcademicLevel: ConceptValues;
  genderValues: ConceptValues;
  maritalStatusValues: ConceptValues;
  ministerTypes: ConceptValues;
  ministerLevels: ConceptValues;


  // OBJETO MINISTRO
  minister: Minister = {
    expiry_date_credential: null,
    phone: null,
    cell_phone: null,
    married_years: null,
    spouse_name: null,
    ministry_start_date: null,
    labor_ministry: null,
    minister_type: null,
    user_id: null,
    church_id: null,
    academic_trainings: [],
    ministerial_trainings: [],
    children: [],
    church: null
  }

  // OBJETOS PARA FORMACIÓN MINISTERIAL Y FORMACIÓN ACADÉMICA
  primaria = new AcademicTraining();
  primariaChecked: boolean = false;

  bachillerato = new AcademicTraining();
  bachilleratoChecked: boolean = false;

  universidad = new AcademicTraining();
  universidadChecked: boolean = false;

  posgrado = new AcademicTraining();
  posgradoChecked: boolean = false;

  seminarioBiblico = new MinisterialTraining();
  seminarioBiblicoChecked: boolean = false;

  isum = new MinisterialTraining();
  isumChecked: boolean = false;

  fatad = new MinisterialTraining();
  fatadChecked: boolean = false;

  otro = new MinisterialTraining();
  otroChecked: boolean = false;

  //ARCHIVOS REQUERIDOS
  cedulaFile: any = null;
  rutFile: any = null;
  registroMatrimonioFile: any = null;
  credencialFile: any = null;

  anosEgresos: number[] = [];
  credentialMonts: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  credentialYears: number[] = [];
  monthExpiryDateSelected: string = null;
  yearExpiryDateSelected: number = null;

  constructor(private generalService: GeneralService,
    private router: Router,
    private ministerService: MinisterService,
    private churchService: ChurchService,
    private loginService: LoginService,
    private dialog: MatDialog) { }

  ngOnInit() {



    let currentYear: number = new Date().getFullYear();
    for (let i = currentYear; i >= 1950; i--) {
      this.anosEgresos.push(i);
    }

    for (let i = 2005; i <= 2050; i++) {
      this.credentialYears.push(i);
    }

    this.ministerService.getMinisterByUserId()
      .subscribe((minister) => {

        this.dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Lo sentimos',
            content: "Usted ya tiene una postulación como ministro"
          }
        })

        console.log('No puede postular a ministro');

        // PARA QUITAR EL LINK QUE PERMITE POSTULARSE A MINISTRO
        this.loginService.ingresoUsuario.emit();

        this.router.navigate(['/', 'admin', 'ministers', 'minister-list']);

      })

    let user = JSON.parse(localStorage.getItem('user'));
    this.minister.user_id = user.id;

    // SE ASUME QUE ESTE FORMULARIO ES PARA EL TIPO DE MINISTRO MÁS BÁSICO Y ESTADO 02:PENDIENTE
    //this.minister.level = '04';
    this.minister.state = '02';


    // VERIFICA SI EL MIEMBRO YA ES MINISTRO... SI YA LO ES, SE REDIRECCIONA A LA LISTA DE MINISTROS
    if (user.is_academic) {
      this.dialog.open(AlertComponent, {
        width: '35vw',
        disableClose: true,
        data: {
          title: 'Lo sentimos',
          content: "Usted ya es ministro"
        }
      })

      this.router.navigate(['/', 'admin', 'ministers', 'minister-list']);

      return;
    }

    // SE AGREGA UN CAMPO HIDDEN PARA ENVIAR EL ATRIBUTO TYPE DE CADA AcademicTraining y MinisterialTraining
    this.primaria.level = '01';
    this.bachillerato.level = '02';
    this.universidad.level = '03';
    this.posgrado.level = '04';

    this.seminarioBiblico.type = '01';
    this.isum.type = '02';
    this.fatad.type = '03';
    this.otro.type = '04';

    // SE CARGAN TODAS LAS LISTAS DE VALOR
    this.churchService.getAllChurches()
      .subscribe((data: Church[]) => {
        this.allChurches = data;

        this.setChurchFilterOptions();

      })

    this.academicLevels = this.generalService.concepts[11];
    if (this.academicLevels == null) {
      this.generalService.getConceptDataById(11).subscribe(
        (data: Concept) => {
          this.academicLevels = data.values;
        },
        (error) => {
          console.log('error', error)
          this.router.navigate(['/admin', 'members']);
        });
    }

    this.ministerAcademicLevel = this.generalService.concepts[12];
    if (this.ministerAcademicLevel == null) {
      this.generalService.getConceptDataById(12).subscribe(
        (data: Concept) => {
          this.ministerAcademicLevel = data.values;
        },
        (error) => {
          console.log('error', error)
          this.router.navigate(['/admin', 'members']);
        });
    }

    this.maritalStatusValues = this.generalService.concepts[2]
    if (this.maritalStatusValues == null) {
      this.generalService.getConceptDataById(2).subscribe((data: Concept) => {
        this.maritalStatusValues = data.values
      })
    }

    this.genderValues = this.generalService.concepts[3]
    if (this.genderValues == null) {
      this.generalService.getConceptDataById(3).subscribe((data: Concept) => {
        this.genderValues = data.values
      })
    }

    this.ministerTypes = this.generalService.concepts[13]
    if (this.ministerTypes == null) {
      this.generalService.getConceptDataById(13).subscribe((data: Concept) => {
        this.ministerTypes = data.values
      })
    }

    this.ministerLevels = this.generalService.concepts[10]
    if (this.ministerLevels == null) {
      this.generalService.getConceptDataById(10).subscribe((data: Concept) => {
        this.ministerLevels = data.values
        //console.log(this.ministerLevels);
      })
    }

  }

  setChurchFilterOptions() {
    this.filteredChurches = this.myControl.valueChanges.pipe(
      startWith(''),
      map(val => this.filterChurch(val))
    );
  }

  displayFnChurch(church?: Church): string | undefined {
    return church ? church.name : undefined;
  }

  filterChurch(opt: any): Church[] {
    if (typeof (opt) == "string") {
      return this.allChurches.filter(option => option.name.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
    } else if (typeof (opt) == "object") {
      return this.allChurches.filter(option => option.name.toLowerCase().indexOf(opt.name.toLowerCase()) !== -1);
    } else {
      return this.allChurches;
    }
  }


  // FUNCION PARA DETERMINAR LAS IGLESIAS A MOSTRAR EN EL AUTOCOMPLETE, SEGÚN EL TIPO DE MINISTRO INGRESADO
  ministerTypeChanged(event: any) {

    return;

    /* this.optionsChurches = [];

    for (let church of this.allChurches) {

      if (this.minister.minister_type == '01' && church.church_type == '01') {
        this.optionsChurches.push(church);
      }
      else if (this.minister.minister_type == '02' && church.church_type == '02') {
        this.optionsChurches.push(church);
      }

    }
 */
  }

  // FUNCIÓN PARA AGREGAR UN NUEVO OBJETO HIJO 
  addChild() {
    this.minister.children.push(new Child());
  }

  postulate() {

    if (this.monthExpiryDateSelected && this.yearExpiryDateSelected) {
      this.minister.expiry_date_credential = this.monthExpiryDateSelected + '/' + this.yearExpiryDateSelected.toString();
    }

    console.log(this.minister.expiry_date_credential);

    this.minister.church_id = this.churchSelected.id;

    // SE AGREGAN AL OBJETO MINISTRO, TODOS LOS OBJETOS FORMACIÓN MINISTERIAL Y FORMACIÓN ACÁDEMICA QUE FUERON LLENADOS
    if (this.primariaChecked) {
      this.minister.academic_trainings.push(this.primaria);
    }
    if (this.bachilleratoChecked) {
      this.minister.academic_trainings.push(this.bachillerato);
    }
    if (this.universidadChecked) {
      this.minister.academic_trainings.push(this.universidad);
    }
    if (this.posgradoChecked) {
      this.minister.academic_trainings.push(this.posgrado);
    }

    if (this.seminarioBiblicoChecked) {
      this.minister.ministerial_trainings.push(this.seminarioBiblico);
    }
    if (this.isumChecked) {
      this.minister.ministerial_trainings.push(this.isum);
    }
    if (this.fatadChecked) {
      this.minister.ministerial_trainings.push(this.fatad);
    }
    if (this.otroChecked) {
      this.minister.ministerial_trainings.push(this.otro);
    }


    let files = {
      'cedula': this.cedulaFile,
      'rut': this.rutFile,
      'registroMatrimonio': this.registroMatrimonioFile,
      'credencial': this.credencialFile
    };

    // SE VALIDA SI EL HIJO NO FUE COMPLETADO CORRECTAMENTE

    for (let i = this.minister.children.length - 1; i >= 0; i--) {
      if (this.minister.children[i].name == '' || this.minister.children[i].name == null) {
        console.log('Borrar hijo');
        this.minister.children.splice(i, 1);
      }
    }

    let auxDate = <Date>this.minister.ministry_start_date;
    this.minister.ministry_start_date = `${auxDate.getFullYear()}/${auxDate.getMonth() + 1}/${auxDate.getDay()}`;

    //console.log(this.minister);

    this.ministerService.postulate(this.minister, files)
      .subscribe((data) => {

        this.dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Felicitaciones',
            content: "Postulación ingresada correctamente"
          }
        })

        this.router.navigate(['/', 'admin', 'ministers', 'minister-list']);
      }, (error) => {

        // PARA RESTAURAR EL VALOR QUE INGRESÓ EL USUARIO
        this.minister.ministry_start_date = auxDate;

        this.dialog.open(AlertComponent, {
          width: '35vw',
          disableClose: true,
          data: {
            title: 'Lo sentimos',
            content: "Hubo un error al intentar postular"
          }
        })
      })
  }

  // FUNCIONES PARA CARGAR ARCHIVOS SUBIDOS POR EL USUARIO
  onCedulaFileSelected(event) {
    this.cedulaFile = event.target.files[0];
  }

  onRutFileSelected(event) {
    this.rutFile = event.target.files[0];
  }

  onRegistroMatrimonioFileSelected(event) {
    this.registroMatrimonioFile = event.target.files[0];
  }

  onCredencialFileSelected(event) {
    this.credencialFile = event.target.files[0];
  }

  canSave(): boolean {
    if (!this.churchSelected) {
      return false;
    }
    else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/ministers/postulate-minister/postulate-minister.component.ts